import { AestheticMedicineExperienceMT } from "./v1";

export type AestheticMedicineExperienceMTV1Type = keyof typeof AestheticMedicineExperienceMT;

export type AestheticMedicineExperienceMTType = AestheticMedicineExperienceMTV1Type;
